/*
 * From https://www.redblobgames.com/x/2233-android-wallpaper/
 * Copyright 2022 Red Blob Games <redblobgames@gmail.com>
 * @license Apache-2.0 <https://www.apache.org/licenses/LICENSE-2.0.html>
 */
'use strict';

import { createNoise2D } from "simplex-noise";
const img = document.querySelector("figure img") as HTMLImageElement;

function draw() {
    const {width, height} = img;

    console.log(width, height);

    const canvas = document.querySelector("#wallpaper") as HTMLCanvasElement;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    const statusBottom = 75;
    const mainTop = 275;
    const mainBottom = 1220;
    const navigationTop = 1400;
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, width, statusBottom);
    ctx.fillStyle = "hsl(330, 50%, 20%)";
    ctx.fillRect(0, statusBottom, width, mainTop - statusBottom);
    ctx.fillStyle = "hsl(250, 50%, 20%)";
    ctx.fillRect(0, mainTop, width, mainBottom - mainTop);
    ctx.fillStyle = "hsl(30, 50%, 20%)";
    ctx.fillRect(0, mainBottom, width, navigationTop - mainBottom);
    ctx.fillStyle = "black";
    ctx.fillRect(0, navigationTop, width, height - navigationTop);
}

if (img.complete) draw(); else img.onload = draw;
